/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Law_P2_AfterInputs */

const es_l7_law_p2_after = /** @type {(inputs: L7_Law_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` firme un contrato de gestión y tramite el cambio de uso. Zarpar es esa gestora — y la que menos cobra por serlo.`)
};

const gl_l7_law_p2_after = /** @type {(inputs: L7_Law_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` asine un contrato de xestión e tramite o cambio de uso. Zarpar é esa xestora — e a que menos cobra por selo.`)
};

const en_l7_law_p2_after = /** @type {(inputs: L7_Law_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` signs a management contract and processes the change of use. Zarpar is that manager — and charges the least for it.`)
};

/**
* | output |
* | --- |
* | "signs a management contract and processes the change of use. Zarpar is that manager — and charges the least for it." |
*
* @param {L7_Law_P2_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_law_p2_after = /** @type {((inputs?: L7_Law_P2_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Law_P2_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_law_p2_after(inputs)
	if (locale === "en") return en_l7_law_p2_after(inputs)
	return es_l7_law_p2_after(inputs)
});